import React from 'react';

export const DHeader = ({ children, style, className, as }) => {
  const Component = as || 'p';

  if (style == null) {
    return (
      <Component className={['h3', className].filter(Boolean).join(' ')}>
        {children}
      </Component>
    );
  }

  return (
    <Component className={className} style={style}>
      {children}
    </Component>
  );
};

export default DHeader;

